














































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BaseVue from '../../core/BaseVue';
import UserService from '@/services/user.service';
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import PorposalUserReportEvaluations from '../../models/porposal/porposalUserReportEvaluations.model';
import { ProposalReportEvaluationType } from '@/enums/ProposalReportEvaluationType';

@Component({
    components : {
        ResearchCenterBasicInformationComponent
    }
})
export default class PorposalPendingReportEvaluationTable extends GenericBTable<PorposalUserReportEvaluations> {

    @Prop() public type!: ProposalReportEvaluationType;
    private annoucementId:number = null;
    private code: string = "";
    private codes: string = "";

    get user() {
        return this.$store.state.user;
    }
   
    created() {
        this.tableConfig.controller = `PorposalUserReportEvaluation/GetReportsByUser/${this.user.id}/AndType/${this.type}`;
        this.formatColumns();
    }

    @Watch("annoucementId")
    getByAnnoucement() {
        this.tableConfig.whereParams = `PorposalUserReport/Proposal/AnnoucementId eq ${this.annoucementId}`;
        this.tableConfig.reload();
    }

    @Watch("code")
    getByCode() {
        this.tableConfig.whereParams = `contains(PorposalUserReport/Proposal/Code, '${this.code}')`;
        this.tableConfig.reload();
    }

    public formatColumns() {
        let docTitle = new BTableColumn("docTitle", "table.title", true);
        let name = new BTableColumn("name", "table.proposal", true);
        let researchCenter = new BTableColumn("researchCenter", "table.researchCenter", true);
        let state = new BTableColumn("state", "table.state", true);

        researchCenter.customTemplate = true;
        docTitle.customTemplate = true;
        name.customTemplate = true;
        state.customTemplate = true;
        name.width = '40%';
        researchCenter.width = '35%';
        docTitle.width = '5%';

        this.tableConfig.insertColumns(name, researchCenter,  state);
        
        this.tableConfig.actions.customTemplate = true;
        this.tableConfig.enableDefaultColumns = false;
    }

    public verOpciones(row: PorposalUserReportEvaluations) {
        if (this.type == ProposalReportEvaluationType.ReportEvaluation) this.$router.push(`/propuesta/report/${row.id}/detail`);
        else this.$router.push(`/propuesta/report/budget/${row.id}/detail`);
    }

    public searchByCode(event: any) {
        if (event.keyCode === 13) {
            this.code = this.codes.trim();
        }
    }
}
